import React, {useEffect, useState} from 'react';
import userService from "../..//services/user-service";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import LoginComponent from "./components/login";
import {useQuery} from "@tanstack/react-query";
import Loader from "../../components/loader";
const SITE_KEY = process.env.REACT_APP_CAPTCHA_SITE_KEY;

const Login = () => {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        document.title = "SISTEMA INTERNO";
    }, []);

    const {data: isPrivate} = useQuery({
        queryFn: () => userService.isPrivate().then((data) => {
            setIsLoading(false);
            return data === 1;
        }),
        queryKey: ['isPrivate'],
        initialData: null
    });

    return (
        <>
            {isLoading && <Loader/>}

            {
                isPrivate === true &&
                <LoginComponent
                    isPrivate={isPrivate}
                    setIsLoading={setIsLoading}
                />
            }

            {
                isPrivate === false &&
                <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY}>
                    <LoginComponent
                        isPrivate={isPrivate}
                        setIsLoading={setIsLoading}
                    />
                </GoogleReCaptchaProvider>
            }
        </>
    );
};

export default Login;